import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const SaveClientsDentalPlanDetails = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_CLIENT_DENTAL_PLAN_DETAILS, payload, token)
  return res;
};

export const GetClientsDentalPlanDetails = async(clientId, userId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_DENTAL_PLAN_DETAILS + `ClientID=${clientId}&UserID=${userId}`, token)
  return res;
};

export const GetClientsDentalPlanDetailsByID = async (clientId, userId, planId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_DENTAL_PLAN_DETAILS_BY_ID + `ClientID=${clientId}&UserID=${userId}&CDentalPlanID=${planId}`, token)
  return res;
};
